import type {ScopeFilter} from './types';

export const SCOPE_FILTER_ORDER: ReadonlyArray<ScopeFilter> = [
  'all',
  'INTERNAL',
  'CLIENT',
  'GROUP',
  'BROKER',
  'TPA',
];

export const AUDIT_ACTION_LABELS: Record<string, string> = {
  create: 'Role created',
  update: 'Settings updated',
  delete: 'Role deleted',
  set_permissions: 'Permissions updated',
  promote: 'Promoted to built-in (custom permissions pruned)',
  prune_permissions: 'Non-catalog permissions pruned on sync',
  remove_deprecated: 'Deprecated role removed',
};
